import { Fragment } from 'react';

import { TagV2Variant } from '@zola/zola-ui/src/components/Tag/TagV2.styles';
import { COLORS3 } from '@zola/zola-ui/src/styles/emotion';

import { useSearchResultsPageContext } from '~/pages/couples/explore/components/SearchResults/contexts/SearchResultsPageContext';

import { PageSection } from '../../../PageSection/PageSection';
import { TopPicks } from './TopPicks';

import styles from './topPicksSection.module.less';

export const TopPicksSection = () => {
  const { showTopPicks } = useSearchResultsPageContext();

  if (showTopPicks) {
    return (
      <PageSection backgroundColor={COLORS3.CLOUD_100} noPadding>
        <TopPicks
          vendorCardProps={{ badgeColorVariant: TagV2Variant.SILVER }}
          className={styles.topPicks}
        />
      </PageSection>
    );
  }
  return <Fragment />;
};
